import fileSchema from "@repo/components/src/utils/yup/fileSchema";
import moneySchema from "@repo/components/src/utils/yup/moneySchema";
import * as yup from "yup";

export const productInputSchema = yup.object({
  name: yup.string().required("Ingrese un nombre para el producto"),
  price: moneySchema.required("Ingrese un precio estimado del producto"),
  description: yup
    .string()
    .required("Ingrese una descripción para el producto"),
  image: fileSchema.nullable(),
});
